export default __webpack_public_path__ + "static/670-cef24a8987caaf3635c6c670fe08592a.gif";